export default "__VITE_ASSET__CjN6k$yi__"